export default function Button({ children, onClick, variant='primary', size='md', disabled=false, className='' }) {
  const base = 'touch-btn rounded-xl font-semibold transition-all active:scale-95 select-none flex items-center justify-center gap-2'
  const variants = {
    primary:   'bg-blue-600 hover:bg-blue-700 text-white shadow-md',
    secondary: 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 shadow-sm',
    danger:    'bg-red-500 hover:bg-red-600 text-white shadow-md',
    success:   'bg-green-500 hover:bg-green-600 text-white shadow-md',
    ghost:     'bg-transparent hover:bg-gray-100 text-gray-600',
  }
  const sizes = { sm:'px-4 py-2 text-sm min-h-10', md:'px-6 py-3 text-base min-h-12', lg:'px-8 py-4 text-lg min-h-14', xl:'px-10 py-5 text-xl min-h-16' }
  return (
    <button onClick={onClick} disabled={disabled}
      className={`${base} ${variants[variant]} ${sizes[size]} ${disabled ? 'opacity-40 pointer-events-none' : ''} ${className}`}>
      {children}
    </button>
  )
}
